/* eslint-disable max-lines */
import { FunctionalityEnum } from '@elearning-platform/api-types/enums';

import { RouteGroupName, RouteNameEnum } from '../enums';
import { RouteGroup } from '../interfaces';

// eslint-disable-next-line @typescript-eslint/typedef
export const routingConfig = {
  [RouteGroupName.Base]: {
    urls: {
      pl: '/',
      en: '/',
    },
    children: {
      [RouteNameEnum.IncomingAuth]: {
        urls: {
          pl: '/incoming-auth/:internalToken/:authToken',
          en: '/incoming-auth/:internalToken/:authToken',
        },
        title: 'competence.app.routingConfig.incomingAuth.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ComparisonTable]: {
        urls: {
          pl: '/porownaj-oferty-ubezpieczen',
          en: '/compare-insurance-offers',
        },
        title: 'competence.app.routingConfig.comparisonTable.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ConfirmEmail]: {
        urls: {
          pl: '/confirm-email',
          en: '/confirm-email',
        },
        title: 'competence.app.routingConfig.confirmEmail.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.EmailVerification]: {
        urls: {
          pl: '/email-verification/:token',
          en: '/email-verification/:token',
        },
        title: 'competence.app.routingConfig.emailVerification.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.AnonSurvey]: {
        urls: {
          pl: '/ankieta/:id',
          en: '/ankieta/:id',
        },
        title: 'competence.app.routingConfig.anonSurvey.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Dashboard]: {
        urls: {
          pl: '/pulpit',
          en: '/pulpit',
        },
        title: 'competence.app.routingConfig.dashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiDashboard,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Form]: {
        urls: {
          pl: '/formularze/:id',
          en: '/formularze/:id',
        },
        title: 'competence.app.routingConfig.form.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSurveyInit,
          FunctionalityEnum.ApiSurveySave,
          FunctionalityEnum.ApiSurveySummary,
          FunctionalityEnum.ApiSurveyFinish,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Idd]: {
        urls: {
          pl: '/idd',
          en: '/idd',
        },
        title: 'competence.app.routingConfig.idd.title',
        secured: true,
        requiredFunctionalities: [
          'api_user_idd_dashboard' as FunctionalityEnum,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.KnowledgeBase]: {
        urls: {
          pl: '/lekcje',
          en: '/lessons',
        },
        title: 'competence.app.routingConfig.knowledgeBase.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiLearningList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.KnowledgeBaseLesson]: {
        urls: {
          pl: '/lekcje/:id',
          en: '/lessons/:id',
        },
        title: 'competence.app.routingConfig.knowledgeBaseLesson.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContentInit,
          FunctionalityEnum.ApiContentRelated,
          FunctionalityEnum.ApiContentComments,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Notifications]: {
        urls: {
          pl: '/powiadomienia',
          en: '/powiadomienia',
        },
        title: 'competence.app.routingConfig.notifications.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNotificationList,
          FunctionalityEnum.ApiNotificationRead,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Onboarding]: {
        urls: {
          pl: '/onboarding',
          en: '/onboarding',
        },
        title: 'competence.app.routingConfig.onboarding.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiOnboardingDashboard,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Surveys]: {
        urls: {
          pl: '/formularze',
          en: '/formularze',
        },
        title: 'competence.app.routingConfig.surveys.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSurveyList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Trainings]: {
        urls: {
          pl: '/szkolenia',
          en: '/szkolenia',
        },
        title: 'competence.app.routingConfig.trainings.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiEventsList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TrainingDetails]: {
        urls: {
          pl: '/szkolenia/:id',
          en: '/szkolenia/:id',
        },
        title: 'competence.app.routingConfig.trainingDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiEventsDetails,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.VideoPlayer]: {
        urls: {
          pl: '/wideo/:id',
          en: '/wideo/:id',
        },
        title: 'competence.app.routingConfig.videoPlayer.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContentInit,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.SignIn]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.signIn.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Registration]: {
        urls: {
          pl: '/registration',
          en: '/registration',
        },
        title: 'competence.app.routingConfig.registration.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.AccountActivation]: {
        urls: {
          pl: '/aktywacja',
          en: '/aktywacja',
        },
        title: 'competence.app.routingConfig.accountActivation.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.RemindPassword]: {
        urls: {
          pl: '/remind-password',
          en: '/remind-password',
        },
        title: 'competence.app.routingConfig.remindPassword.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ContactDataConfirm]: {
        urls: {
          pl: '/weryfikacja-danych-kontaktowych/:token',
          en: '/weryfikacja-danych-kontaktowych/:token',
        },
        title: 'competence.app.routingConfig.contactDataConfirm.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PreAccountRegistration]: {
        urls: {
          pl: '/registration/:hash',
          en: '/registration/:hash',
        },
        title: 'competence.app.routingConfig.preAccountRegistration.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Regulations]: {
        urls: {
          pl: '/regulamin',
          en: '/regulamin',
        },
        title: 'competence.app.routingConfig.regulations.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PrivacyPolicy]: {
        urls: {
          pl: '/polityka-prywatnosci',
          en: '/polityka-prywatnosci',
        },
        title: 'competence.app.routingConfig.privacyPolicy.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.InformationDuty]: {
        urls: {
          pl: '/klauzula-informacyjna',
          en: '/klauzula-informacyjna',
        },
        title: 'competence.app.routingConfig.informationDuty.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.TrainingRegulations]: {
        urls: {
          pl: '/regulamin-szkolen',
          en: '/training-regulations',
        },
        title: 'competence.app.routingConfig.trainingRegulations.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.NotFound]: {
        urls: {
          pl: '/nie-znaleziono',
          en: '/nie-znaleziono',
        },
        title: 'competence.app.routingConfig.notFound.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
    },
  },
  [RouteGroupName.Certificates]: {
    urls: {
      pl: '/certyfikaty',
      en: '/certificates',
    },
    children: {
      [RouteNameEnum.Certificates]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.certificates.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCertificateList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CertificatePath]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.certificatePath.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCertificatePathDetails,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Competences]: {
    urls: {
      pl: '/competence',
      en: '/competence',
    },
    children: {
      [RouteNameEnum.Competences]: {
        urls: {
          pl: '/list',
          en: '/list',
        },
        title: 'competence.app.routingConfig.competences.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CompetenceEntry]: {
        urls: {
          pl: '/:id/:tab',
          en: '/:id/:tab',
        },
        title: 'competence.app.routingConfig.competenceEntry.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CompetenceSelfMarkSurvey]: {
        urls: {
          pl: '/:id/self-mark/:measureId',
          en: '/:id/self-mark/:measureId',
        },
        title: 'competence.app.routingConfig.competenceSelfMarkSurvey.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Gamification]: {
    urls: {
      pl: '/gamification',
      en: '/gamification',
    },
    children: {
      [RouteNameEnum.GamificationInit]: {
        urls: {
          pl: '/init',
          en: '/init',
        },
        title: 'competence.app.routingConfig.gamificationInit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationStart]: {
        urls: {
          pl: '/start',
          en: '/start',
        },
        title: 'competence.app.routingConfig.gamificationStart.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationSurvey]: {
        urls: {
          pl: '/survey/:id',
          en: '/survey/:id',
        },
        title: 'competence.app.routingConfig.gamificationSurvey.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationTask]: {
        urls: {
          pl: '/task/:id',
          en: '/task/:id',
        },
        title: 'competence.app.routingConfig.gamificationTask.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationNews]: {
        urls: {
          pl: '/news/:id',
          en: '/news/:id',
        },
        title: 'competence.app.routingConfig.gamificationNews.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationPoints]: {
        urls: {
          pl: '/points',
          en: '/points',
        },
        title: 'competence.app.routingConfig.gamificationPoints.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.News]: {
    urls: {
      pl: '/news',
      en: '/news',
    },
    children: {
      [RouteNameEnum.News]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.news.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNews,
          FunctionalityEnum.ApiNewsList,
          FunctionalityEnum.ApiNewsRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.NewsEntry]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.newsEntry.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNews,
          FunctionalityEnum.ApiNewsRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Profile]: {
    urls: {
      pl: '/profil',
      en: '/profile',
    },
    children: {
      [RouteNameEnum.ProfileDetails]: {
        urls: {
          pl: '/details',
          en: '/details',
        },
        title: 'competence.app.routingConfig.profileDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiUserExperiences,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileEdit]: {
        urls: {
          pl: '/edit',
          en: '/edit',
        },
        title: 'competence.app.routingConfig.profileEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiProfileReadForm,
          FunctionalityEnum.ApiProfileUpdate,
          FunctionalityEnum.ApiBrands,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileAgreementsAndCookies]: {
        urls: {
          pl: '/agreementsAndCookies',
          en: '/agreementsAndCookies',
        },
        title: 'competence.app.routingConfig.profileAgreementsAndCookies.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileAgreements]: {
        urls: {
          pl: '/agreements',
          en: '/agreements',
        },
        title: 'competence.app.routingConfig.profileAgreements.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiAgreementUpdate,
          FunctionalityEnum.ApiAgreementList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileCookies]: {
        urls: {
          pl: '/cookies',
          en: '/cookies',
        },
        title: 'competence.app.routingConfig.profileCookies.title',
        secured: true,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfilePasswords]: {
        urls: {
          pl: '/pass',
          en: '/pass',
        },
        title: 'competence.app.routingConfig.profilePasswords.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUserUpdatePassword,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileDocuments]: {
        urls: {
          pl: '/documents',
          en: '/documents',
        },
        title: 'competence.app.routingConfig.profileDocuments.title',
        secured: true,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileFacsimile]: {
        urls: {
          pl: '/facsimile',
          en: '/facsimile',
        },
        title: 'competence.app.routingConfig.profileFacsimile.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileFacsimileDownload,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileArchives]: {
        urls: {
          pl: '/archiwum',
          en: '/archive',
        },
        title: 'competence.app.routingConfig.profileArchive.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiDocumentArchiveDocumentsList,
          FunctionalityEnum.ApiDocumentArchiveDocumentDownload,
          FunctionalityEnum.ApiDocumentArchiveDocumentDelete,
        ],
        roleVisibilityMode: 'forAll',
      },
    },
  },
  [RouteGroupName.Substitutions]: {
    urls: {
      pl: '/zastepstwa',
      en: '/substitutions',
    },
    children: {
      [RouteNameEnum.SubstitutionCreate]: {
        urls: {
          pl: '/nowe',
          en: '/nowe',
        },
        title: 'competence.app.routingConfig.substitutionCreate.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.SubstitutionsDashboard]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.substitutionsDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
          FunctionalityEnum.ApiSubstitutionsList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.SubstitutionsList]: {
        urls: {
          pl: '/lista/:viewType',
          en: '/lista/:viewType',
        },
        title: 'competence.app.routingConfig.substitutionsList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
          FunctionalityEnum.ApiSubstitutionsList,
        ],
        roleVisibilityMode: 'forAll',
      },
    },
  },
  [RouteGroupName.TeamIndicators]: {
    urls: {
      pl: '/indicators',
      en: '/indicators',
    },
    children: {
      [RouteNameEnum.TeamIndicatorsStrategic]: {
        urls: {
          pl: '/strategic',
          en: '/strategic',
        },
        title: 'competence.app.routingConfig.teamIndicatorsStrategic.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TeamIndicatorsCommon]: {
        urls: {
          pl: '/common',
          en: '/common',
        },
        title: 'competence.app.routingConfig.teamIndicatorsCommon.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TeamIndicatorsStatistics]: {
        urls: {
          pl: '/statistics',
          en: '/statistics',
        },
        title: 'competence.app.routingConfig.teamIndicatorsStatistics.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.UsersAdministration]: {
    urls: {
      pl: '/zarzadzanie',
      en: '/users-management',
    },
    children: {
      [RouteNameEnum.UsersAdministrationCompaniesList]: {
        urls: {
          pl: '/firmy',
          en: '/companies',
        },
        title: 'competence.app.routingConfig.usersAdministrationCompaniesList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCompanyList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationDashboard]: {
        urls: {
          pl: '/dashboard',
          en: '/dashboard',
        },
        title: 'competence.app.routingConfig.usersAdministrationDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCompanyList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUserDetails]: {
        urls: {
          pl: '/uzytkownicy/:id',
          en: '/uzytkownicy/:id',
        },
        title: 'competence.app.routingConfig.usersAdministrationUserDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUserDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUsersList]: {
        urls: {
          pl: '/firmy/:id/uzytkownicy',
          en: '/companies/:id/uzytkownicy',
        },
        title: 'competence.app.routingConfig.usersAdministrationUsersList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUsersList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCompanyDashboard]: {
        urls: {
          pl: '/firmy/:id',
          en: '/companies/:id',
        },
        title: 'competence.app.routingConfig.usersAdministrationCompanyDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUsersList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCyclicalLessons]: {
        urls: {
          pl: '/firmy/:id/lekcje-cykliczne',
          en: '/companies/:id/cyclical-lessons',
        },
        title: 'competence.app.routingConfig.usersAdministrationCyclicalLessons.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCyclicalLessonsList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCourses]: {
        urls: {
          pl: '/firmy/:id/szkolenia',
          en: '/companies/:id/courses',
        },
        title: 'competence.app.routingConfig.usersAdministrationCourses.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCoursesList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
  [RouteGroupName.LegalForms]: {
    urls: {
      pl: '/dokumenty-formalne',
      en: '/legal-forms',
    },
    children: {
      [RouteNameEnum.LegalFormEdit]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.legalFormEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiLegalForms,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.LegalFormsAttemptsList]: {
        urls: {
          pl: '/weryfikacja/:type',
          en: '/verification/:type',
        },
        title: 'competence.app.routingConfig.legalFormsAttemptsList.title',
        secured: true,
        requiredFunctionalities: [
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
} satisfies Record<RouteGroupName, RouteGroup>;
